/* unplugin-vue-components disabled */import { render } from "./Mapping.vue?vue&type=template&id=4934fa1d"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__